import { WorkType } from '../Entities/Dto/AddActivityDto';
import { devLogger } from '../helpers/devLogger';
import { OverviewContext } from './Context/OverviewContext';

export const shouldResetAlignStatus = (workType: WorkType) => {
    const enableAlignContract = OverviewContext.Settings.EnableAlignContract;
    const alignContractStatuses = OverviewContext.Settings.AlignContractStatuses;
    const overrideAlignContractOnAllocationChange = OverviewContext.Settings.OverrideAlignContractOnAllocationChange;
    const overrideAlignContractOnRequestChange = OverviewContext.Settings.OverrideAlignContractOnRequestChange;

    if (
        enableAlignContract &&
        alignContractStatuses &&
        alignContractStatuses.length &&
        ((overrideAlignContractOnAllocationChange && overrideAlignContractOnAllocationChange.length > 0 && workType === WorkType.Allocation) ||
            (overrideAlignContractOnRequestChange && overrideAlignContractOnRequestChange.length > 0 && workType === WorkType.Request))
    ) {
		// Make sure the selected align status is in the list of align statuses.
		// There are scenarios where the align status is not in the list of align statuses.
        const selectedAlignStatusId = getAlignStatusId(workType);
        if (!alignContractStatuses.find(status => status.Id === selectedAlignStatusId)) {
            return false;
        }
        return true;
    } else {
        return false;
    }
};

export const resetAlignStatus = (workType: WorkType) => {
    const selectedAlignStatusId = getAlignStatusId(workType);
    const resetTo = OverviewContext.Settings.AlignContractStatuses.find(status => status.Id === selectedAlignStatusId).Id;
    devLogger.log('resetting to', resetTo);
    return resetTo;
};

const getAlignStatusId = (workType: WorkType) => {
    switch (workType) {
        case WorkType.Allocation:
            return OverviewContext.Settings.OverrideAlignContractOnAllocationChange;
        case WorkType.Request:
            return OverviewContext.Settings.OverrideAlignContractOnRequestChange;
    }
};
